module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-SemiBold-ee3d8dd6dfeb4591d07b1bb220d040e6.otf";